import React from 'react';
import { TEXT_STYLES_GROUP, TEXT_SECTION_RANK, TEXT_SECTION, TEXT_STYLES_MENU, TEXT_STYLES_GROUP_RANK, TEXT_STYLES_MENU_SECTION, TEXT_STYLES_MENU_RANK } from '@atlaskit/editor-common/toolbar';
import { toolbarBlockTypesWithRank } from '../block-types';
import { HeadingButton } from './ToolbarBlockType/HeadingButton';
import { QuoteButton } from './ToolbarBlockType/QuoteButton';
import { TextStylesMenuButton } from './ToolbarBlockType/TextStylesMenuButton';
export var getToolbarComponents = function getToolbarComponents(api) {
  var toolbarComponents = [{
    type: TEXT_STYLES_GROUP.type,
    key: TEXT_STYLES_GROUP.key,
    parents: [{
      type: TEXT_SECTION.type,
      key: TEXT_SECTION.key,
      rank: TEXT_SECTION_RANK[TEXT_STYLES_GROUP.key]
    }]
  }, {
    type: TEXT_STYLES_MENU.type,
    key: TEXT_STYLES_MENU.key,
    parents: [{
      type: TEXT_STYLES_GROUP.type,
      key: TEXT_STYLES_GROUP.key,
      rank: TEXT_STYLES_GROUP_RANK[TEXT_STYLES_MENU.key]
    }],
    component: function component(_ref) {
      var children = _ref.children;
      return /*#__PURE__*/React.createElement(TextStylesMenuButton, {
        api: api
      }, children);
    }
  }, {
    type: TEXT_STYLES_MENU_SECTION.type,
    key: TEXT_STYLES_MENU_SECTION.key,
    parents: [{
      type: TEXT_STYLES_MENU.type,
      key: TEXT_STYLES_MENU.key,
      rank: TEXT_STYLES_MENU_RANK[TEXT_STYLES_MENU_SECTION.key]
    }]
  }];
  Object.values(toolbarBlockTypesWithRank()).forEach(function (blockType) {
    if (blockType.toolbarKey) {
      var menuItem = {
        type: 'menu-item',
        key: blockType.toolbarKey,
        parents: [{
          type: TEXT_STYLES_MENU_SECTION.type,
          key: TEXT_STYLES_MENU_SECTION.key,
          rank: blockType.toolbarRank
        }],
        component: blockType.name === 'blockquote' ? function () {
          return /*#__PURE__*/React.createElement(QuoteButton, {
            blockType: blockType,
            api: api
          });
        } : function () {
          return /*#__PURE__*/React.createElement(HeadingButton, {
            blockType: blockType,
            api: api
          });
        }
      };
      toolbarComponents.push(menuItem);
    }
  });
  return toolbarComponents;
};